export class PQrWaiterFulfillmentTime {
    constructor() {
        this.isEditable = false;
        this.optionValue = "ASAP";
    }
    get hourValue() {
        throw new Error("QrWaiter fulfillment time cannot have hour value");
    }
    get dateValue() {
        throw new Error("QrWaiter fulfillment time cannot have date value");
    }
    get options() {
        throw new Error("QrWaiter fulfillment time cannot have options");
    }
    setOption() {
        throw new Error("QrWaiter fulfillment time cannot set option");
    }
    setDate() {
        throw new Error("QrWaiter fulfillment time cannot set date");
    }
    setHour() {
        throw new Error("QrWaiter fulfillment time cannot set hour");
    }
    get fulfillmentTimeStatus() {
        return { type: "AllAvailable" };
    }
}
